import { render, staticRenderFns } from "./PrintComponent.vue?vue&type=template&id=47bf2c52&"
import script from "./PrintComponent.vue?vue&type=script&lang=ts&"
export * from "./PrintComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports